import React from 'react';
import { NavLink } from 'react-router-dom';
import { Rocket } from 'lucide-react';
import { LAYOUT_CONFIG, NAV_MENU_CONFIG } from '../../utils/constants';

const Sidebar = ({ isOpen }) => {
    return (
        <div className={`${LAYOUT_CONFIG.sidebar.background} ${LAYOUT_CONFIG.sidebar.border} ${LAYOUT_CONFIG.sidebar.transition} ${LAYOUT_CONFIG.sidebar.position} ${isOpen ? LAYOUT_CONFIG.sidebar.width.open : LAYOUT_CONFIG.sidebar.width.closed
            }`}>
            <div className="p-4 md:p-6">
                <div className="flex items-center gap-3 mb-6 md:mb-8">
                    <div className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                        <Rocket className="w-5 h-5 md:w-6 md:h-6 text-white" />
                    </div>
                    <h2 className="text-lg md:text-xl font-bold text-white">Monitor</h2>
                </div>

                <nav className="space-y-2">
                    {NAV_MENU_CONFIG.items.map((item) => {
                        const IconComponent = item.icon;

                        return (
                            <NavLink
                                key={item.id}
                                to={item.path}
                                className={({ isActive }) =>
                                    `${NAV_MENU_CONFIG.styles.base} ${isActive ? NAV_MENU_CONFIG.styles.active : NAV_MENU_CONFIG.styles.inactive}`
                                }
                            >
                                <IconComponent className="w-4 h-4 md:w-5 md:h-5" />
                                <span className="font-medium">{item.label}</span>
                            </NavLink>
                        );
                    })}
                </nav>
            </div>
        </div>
    );
};

export default Sidebar;
